<template>
  <div v-if="tourneeModele">
    <div class="entete border-entete">
      <div class="is-paddingless section">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3" >
                  {{ $t('detailTourneeModele.title', { nomTournee: tourneeModele.libelle }) }}
                  <b-tag v-if="!tourneeModele.actif"
                        type="has-background-subMenu"
                        class="has-text-white mgl-5px">
                  {{$t('detailTourneeModele.archive')}}
                </b-tag>
                </h1>
                <breadcrumb :breadcrumb="breadcrumb"/>
              </div>
            </div>
          </div>
          <div class="level-right">
            <div class="buttons">
              <button class="button" @click="checkPermissions(permTourneeModele.lecture) ?
              $router.push({name: 'l.logistique.tournee_modele' }) : showPopUp()">
                {{ $t('general.button.return')}}
              </button>

              <dropdownButton
                type="is-addOrEdit"
                v-if="tourneeModele.actif"
                :permission="permTourneeModele.maj"
                :actions="actionSecondary"
                @click="() => {
                  $router.push({name: 'm.logistique.tournee_modele-edit',
                    params: {id: tourneeModele.id }});
                }">
                  {{ $t('detailTourneeModele.actions.edit')}}
              </dropdownButton>

              <dropdownButton
                type="is-addOrEdit"
                class="mgr-2"
                v-else
                :permission="permTourneeModele.maj"
                :actions="actionSecondaryDesarchive"
                @click="launchPopUpArchivage()">
                  {{ $t('general.button.desarchiver') }}
              </dropdownButton>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mgt-20px">
      <div class="card">
        <header class="header-card">
          <p>{{ $t('detailTourneeModele.informationPrincipal.title')}}</p>
        </header>
        <div class="card-content">
          <div class="columns is-multiline">
            <div class="column is-2" v-for="(information, index) in getTableauInformationPrincipal"
                 :key="index">
              <b-field :label="information.title">
                <p class="has-text-link has-text-weight-bold">{{ information.value }}</p>
              </b-field>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pdt-20px">
      <div class="columns level">
        <div class="level-left"></div>
        <div class="level-right">
          <div class="column is-narrow">
            <exportExcelButton
              :perm="permTourneeModele.exporter"
              :action="exporter"/>
          </div>
        </div>
      </div>
    </div>
    <v-client-table :data="tourneeModele.tourneeLignes"
                    class='mgt-20px stickyOnlyOnFirstTr
                    vueTableFilterStyle'
                    :columns="columns"
                    :options="options"
                    ref='tableTourneeLigne'>
    </v-client-table>
    <b-modal v-model="openPopUpArchivage"
             has-modal-card
             class="modal">
      <pop-up-prevention
        v-if="tourneeModele"
        @no="openPopUpArchivage = false"
        @yes="archiverTourneeModele"
        :messagesPopup="messagesErreurPopUp"
        :isErrorPopup.sync="errorPopUp"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        :mess-header="$t(('detailTourneeModele.archivageDesarchiver.'
        + (tourneeModele.actif ? 'archivage' : 'desarchivage')))">
      </pop-up-prevention>
    </b-modal>
    <b-modal v-model="openPopUpSuppression" has-modal-card class="modal">
      <pop-up-prevention
        :messHeader="this.$t('detailTourneeModele.popUpSuppression.title')"
        :cancel="this.$t('general.non')"
        :validate="this.$t('general.oui')"
        :messagesPopup="messagesErreurPopUp"
        :isErrorPopup.sync="errorPopUp"
        @no="openPopUpSuppression = false"
        @yes="deleteTourneeModele"/>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import dropdownButton from '@/components/general/button/dropdownButton';
import breadcrumb from '@/components/general/breadcrumb';
import messageErreur from '@/services/general/messageErreur';
import { get, archiver, deleteTournee } from '@/api/logistique/tourneeModele/index';
import { LISTE_INDEX_JOURS } from '@/configuration/datePickerConf';
import transform from '@/services/devisCommandes/filters/devisCommandeServerTableDataTransformer';
import ucFirst from '@/services/general/ucFirst';
import {
  SORT_ICON, TEXTS, NO_PER_PAGE_VALUE, NO_PAGINATION,
} from '@/configuration/clientTableConf';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { getAll } from '@/api/gabed/face/index';
import { addInformationsOfFacesInLignes } from '@/services/logistique/tourneeModele/addInformationPatrimonialTourneeLigne';
import { TOURNEE_MODELE } from '@/configuration/logistique/permissionsLogistiqueConf';
import { getAffectationRegroupement } from '@/api/produit/produitFace';
import formatIsoDate from '@/services/general/formatIsoDate';
import { ETAT_DISPOSITIF_PUBLICITAIRE } from '@/configuration/gabed/dispositif/dispositifPublicitaire';
import PopUpPrevention from '@/components/general/popUpPrevention';
import messageSucces from '@/services/general/messageSucces';
import validationTourneeModele from '@/services/logistique/tourneeModele/validation';
import exportExcel from '@/api/exportExcel';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import { EXPORT_EXCEL_TOURNEE_LIGNE } from '@/configuration/logistique/tournee/tourneeConf';

const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');
const permissions = createNamespacedHelpers('permissions');

export default {
  name: 'c_tourneeModele',
  data() {
    return {
      tourneeModele: null,
      permTourneeModele: TOURNEE_MODELE,
      openPopUpArchivage: false,
      errorPopUp: false,
      messagesErreurPopUp: [],
      openPopUpSuppression: false,
    };
  },
  components: {
    breadcrumb,
    dropdownButton,
    PopUpPrevention,
    exportExcelButton,
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    async getPatrimonialFaceInformation(tourneeModele) {
      const params = {
        query: {
          ids: tourneeModele.tourneeLignes.map((tournee) => { return tournee.faceId; }),
          societeId: this.societeActiveId,
          nonCommercialisable: null,
        },
        limit: NO_PAGINATION,
      };
      return (await getAll(params)).data.result.items;
    },
    getAgenceLibelle(agenceId) {
      let libelleAgence = '';
      this.societesInformations.forEach((societe) => {
        societe.agences.forEach((agence) => {
          if (agence.id === agenceId) libelleAgence = agence.libelle;
        });
      });
      return libelleAgence;
    },
    async archiverTourneeModele() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.errorPopUp = false;
        this.messagesErreurPopUp = [];
        const tourneeToArchive = (await archiver(this.tourneeModele.id, this.tourneeModele.actif))
          .data.result;
        this.openPopUpArchivage = false;
        messageSucces(this.$i18n.t('detailTourneeModele.messages.success.' + (this.tourneeModele.actif ? 'archivage' : 'desarchivage')));
        this.tourneeModele.actif = tourneeToArchive.actif;
        loadingComponent.close();
      } catch (e) {
        if (e.response && e.response.data.error) {
          validationTourneeModele(e.response, this.messagesErreurPopUp);
          this.errorPopUp = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    async deleteTourneeModele() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.errorPopUp = false;
        this.messagesErreurPopUp = [];
        await deleteTournee(this.$route.params.id);
        this.openPopUpSuppression = false;
        messageSucces(this.$t('detailTourneeModele.messages.success.deleteTournee'));
        loadingComponent.close();
        await this.$router.push({ name: 'l.logistique.tournee_modele' });
      } catch (e) {
        if (e.response && e.response.data.error) {
          validationTourneeModele(e.response, this.messagesErreurPopUp);
          this.errorPopUp = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    launchPopUpArchivage() {
      this.openPopUpArchivage = true;
      this.errorPopUp = false;
      this.messagesErreurPopUp = [];
    },
    launchPopUpSuppression() {
      this.openPopUpSuppression = true;
      this.errorPopUp = false;
      this.messagesErreurPopUp = [];
    },
    getTourneesLignesFiltered() {
      let tLignes = [];
      if (this.$refs.tableTourneeLigne && this.$refs.tableTourneeLigne.filteredData.length > 0) {
        tLignes = this.$refs.tableTourneeLigne.filteredData;
      }
      return tLignes;
    },
    async exporter() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const response = await exportExcel({
          typeDonnee: EXPORT_EXCEL_TOURNEE_LIGNE,
          typeExport: null,
          filtres: transform({
            query: {
              ids: this.allSortedData.map(el => el.faceId),
              societeId: this.societeActiveId,
              nonCommercialisable: null,
            },
          }),
        });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    allSortedData() {
      return this.$refs?.tableTourneeLigne?.$refs?.table?.allFilteredData ?? [];
    },
    breadcrumb() {
      return [
        { title: this.$i18n.t('detailTourneeModele.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('detailTourneeModele.breadcrumb.listeAffichage'), route: { name: 'l.logistique.tournee_modele' }, isActive: false },
        { title: this.$i18n.t('detailTourneeModele.breadcrumb.detailTourneeAffichage'), route: '', isActive: true },
      ];
    },
    getTableauInformationPrincipal() {
      const informationsToDisplay = [
        { title: this.$i18n.t('detailTourneeModele.informationPrincipal.nom'), value: this.tourneeModele.libelle },
        { title: this.$i18n.t('detailTourneeModele.informationPrincipal.jourDepart'), value: ucFirst(LISTE_INDEX_JOURS.find((jour) => { return this.tourneeModele.jourDepart === jour.number; }).libelle) },
        { title: this.$i18n.t('detailTourneeModele.informationPrincipal.nbFaces'), value: this.tourneeModele.tourneeLignes.length },
        { title: this.$i18n.t('detailTourneeModele.informationPrincipal.afficheurAffecte'), value: this.tourneeModele.afficheur ? this.tourneeModele.afficheur.nomCommercial : '' },
      ];
      if (this.societeActive.agences.length > 1) {
        informationsToDisplay.push({ title: this.$i18n.t('detailTourneeModele.informationPrincipal.agence'), value: this.getAgenceLibelle(this.tourneeModele.agenceId) });
      }
      return informationsToDisplay;
    },
    actionSecondary() {
      const actions = [
        {
          label: this.$t('general.button.archiver'),
          action: () => { this.launchPopUpArchivage(); },
          permissionAction: TOURNEE_MODELE.supprimer,
        },
        {
          label: this.$t('detailTourneeModele.actions.delete'),
          action: () => { this.launchPopUpSuppression(); },
          permissionAction: TOURNEE_MODELE.supprimer,
        },
      ];

      return actions;
    },
    actionSecondaryDesarchive() {
      const actions = [
        {
          label: this.$t('detailTourneeModele.actions.delete'),
          action: () => { this.launchPopUpSuppression(); },
          permissionAction: TOURNEE_MODELE.supprimer,
        },
      ];

      return actions;
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        headings: {
          dispositif: this.$i18n.t('detailTourneeModele.tableau.dispositif'),
          materiel: this.$i18n.t('detailTourneeModele.tableau.materiel'),
          face: this.$i18n.t('detailTourneeModele.tableau.face'),
          etat: this.$i18n.t('detailTourneeModele.tableau.etat'),
          format: this.$i18n.t('detailTourneeModele.tableau.format'),
          address: this.$i18n.t('detailTourneeModele.tableau.address'),
          cp: this.$i18n.t('detailTourneeModele.tableau.cp'),
          ville: this.$i18n.t('detailTourneeModele.tableau.ville'),
          reseau: this.$i18n.t('detailTourneeModele.tableau.reseau'),
          commercialisable: this.$i18n.t('detailTourneeModele.tableau.commercialisable'),
          disposition: this.$i18n.t('detailTourneeModele.tableau.disposition'),
        },
        filterable: ['dispositif', 'materiel', 'disposition', 'face', 'etat', 'format', 'adresse', 'cp', 'ville', 'reseau', 'commercialisable'],
        filterByColumn: true,
        listColumns: {
          dispositif: this.dispositif,
          format: this.format,
          materiel: this.materiel,
          etat: this.etat,
          commercialisable: [
            { id: true, text: this.$i18n.t('general.oui') },
            { id: false, text: this.$i18n.t('general.non') },
          ],
        },
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: NO_PAGINATION,
        texts: texts,
        sortIcon: SORT_ICON,
        sortable: ['dispositif', 'materiel', 'disposition', 'face', 'etat', 'format', 'adresse', 'cp', 'ville', 'reseau', 'commercialisable'],
      };
    },
    columns() {
      return ['dispositif', 'materiel', 'disposition', 'face', 'etat', 'format', 'adresse', 'cp', 'ville', 'reseau', 'commercialisable'];
    },
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      societesInformations: 'societesInformations',
      societeActive: 'societeActive',
    }),
    dispositif() {
      const typeDispositifPresent = this.tourneeModele.tourneeLignes.map(t => t.dispositif);
      return (this.parametre(PARAMETRES_KEYS.dispositifType))
        .filter(dispo => typeDispositifPresent.includes(dispo.id))
        .map((dispositif) => ({
          id: dispositif.id,
          text: dispositif.libelle,
        }));
    },
    format() {
      return (this.parametre(PARAMETRES_KEYS.materielFormat)).map((format) => ({
        id: format.id,
        text: format.libelle,
      }));
    },
    materiel() {
      const typeMaterielPresent = this.tourneeModele.tourneeLignes.map(t => t.materiel);
      return (this.parametre(PARAMETRES_KEYS.materielType))
        .filter(materiel => typeMaterielPresent.includes(materiel.id))
        .map((materiel) => ({
          id: materiel.id,
          text: materiel.libelle,
        }));
    },
    etat() {
      return ETAT_DISPOSITIF_PUBLICITAIRE.map((etat) => ({
        id: etat.value,
        text: this.$i18n.t(etat.libelle),
      }));
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      const tourneeModele = (await get(this.$route.params.id)).data.result;
      let patrimonialFaceInformation = [];
      const faceIds = tourneeModele.tourneeLignes
        .map(tournee => tournee.faceId).filter(faceId => faceId);
      if (faceIds.length) {
        patrimonialFaceInformation = await this.getPatrimonialFaceInformation(tourneeModele);
        const reseauInformation = (await getAffectationRegroupement({
          dateVisu: formatIsoDate(new Date()),
          produitIds: patrimonialFaceInformation
            .filter(patrimonialFace => patrimonialFace.produitId)
            .map((patrimonialFace) => patrimonialFace.produitId),
        })).data.result;
        addInformationsOfFacesInLignes(patrimonialFaceInformation, tourneeModele.tourneeLignes,
          reseauInformation);
      }

      await this.loadParametres([PARAMETRES_KEYS.materielType,
        PARAMETRES_KEYS.materielFormat,
        PARAMETRES_KEYS.dispositifType,
      ]);
      tourneeModele.tourneeLignes.sort((a, b) => {
        return a.ordre - b.ordre;
      });
      this.tourneeModele = tourneeModele;
      this.setInformationPage(this.$t('pageGeneral.detail', { item: this.tourneeModele.libelle }));
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
